// extracted by mini-css-extract-plugin
module.exports = {"text":"text--1DPUs"};